import type { CriteriaLibraryReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class CriteriaLibraryViewModel
{
    isOpen = false;

    parentId: number | null = null;
    data: CriteriaLibraryReadModel | null = null;

    show(parentId: number)
    {
        this.parentId = parentId;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.parentId = null;
        this.data = null;
    }

    setData(data: CriteriaLibraryReadModel)
    {
        this.data = data;
    }

    setUsed(names: string[])
    {
        if (!this.data) return;

        const set = new Set(names);

        this.data.CriteriaTemplates.forEach(t =>
        {
            if (set.has(t.Name))
            {
                t.Used = true;
            }
        });
    }
}
